import { Grid } from '@material-ui/core';
import { Create, Datagrid, DateField, DateTimeInput, Edit, FileField, FileInput, Identifier, Labeled, List, RowClickFunction, SimpleForm, TextField, TextInput, WrapperField } from 'react-admin';
import { EmptyBulkActionButtons, MediaPreview, defaultListFilters } from './customized-elements';

export const MediaBrowse = (props: { rowClick?: RowClickFunction; selectedIds?: Identifier[]}) => {

    const { rowClick, selectedIds } = props;

    return (
        <List filters={defaultListFilters} actions={false}
            sort={{ field: 'createdAt', order: 'DESC' }}
            bulkActionButtons={<EmptyBulkActionButtons />}
        >
            <Datagrid rowClick={rowClick}
                selectedIds={selectedIds}
            >
                <WrapperField source="title">
                    <Grid container>
                        <Grid item xs={6}>
                            <Grid item xs={6}>
                                <Labeled>
                                    <TextField source="title" />
                                </Labeled>
                            </Grid>

                            <Grid item xs={6} >
                                <Labeled>
                                    <TextField source="filename" />
                                </Labeled>
                            </Grid>
                        </Grid>

                        <Grid item xs={6}>
                            <MediaPreview source="url" />
                        </Grid>

                    </Grid>
                </WrapperField>
                <DateField source="createdAt" />
            </Datagrid>
        </List>
    )
}

export const MediaList = () => (
    <List filters={ defaultListFilters }
        sort={{ field: 'createdAt', order: 'DESC' }}
        bulkActionButtons={<EmptyBulkActionButtons />}
    >
        <Datagrid rowClick="edit" isRowSelectable={(record) => false}>
            <TextField source="title" />
            <TextField source="filename" />
            <MediaPreview source="url" isThumbnail sortable={ false } />
            <DateField source="createdAt" />
        </Datagrid>
    </List>
)

export const MediaEdit = (props: any) => {
    return (
        <Edit title="Message">
            <SimpleForm>
                <TextInput source="title" required fullWidth />
                <TextInput source="filename" fullWidth />
                <TextInput source="mimeType" disabled fullWidth />
                <TextInput source="url" disabled fullWidth />
                <MediaPreview source="url" isThumbnail={ false } />
                <DateTimeInput source="createdAt" disabled />
            </SimpleForm>
        </Edit>
    )
}

export const MediaCreate = () => {
    return (
        <Create>
            <SimpleForm>
                <TextInput source="title" fullWidth />
                <FileInput source="media">
                    <FileField source="src" title="title" />
                </FileInput>
            </SimpleForm>
        </Create>
    )
}